'use client';

import 'BomdisoftComponents/inputs/code-input/styles.css';
import { toCellValue, typeIntoCode } from 'BomdisoftComponents/inputs/code-input/render';
import { type KeyboardEvent, useRef } from 'react';

export type CodeInputProps = {
  value: string;
  onChange: (next: string) => void;
  label: string;
  length?: number;
  disabled?: boolean;
  testId?: string;
};

export const CodeInput = ({ disabled, label, length = 6, onChange, testId, value }: CodeInputProps) => {
  const cellsRef = useRef<Array<HTMLInputElement | null>>([]);

  const setCell = (index: number, cell: string) => {
    const entry = typeIntoCode(value, index, cell, length);
    onChange(entry.value);
    if (entry.focusIndex !== null) cellsRef.current[entry.focusIndex]?.focus();
  };

  const onKeyDown = (index: number) => (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Backspace' && !event.currentTarget.value && index > 0) {
      cellsRef.current[index - 1]?.focus();
    }
  };

  return (
    <div className='bomdisoft-code-input-cells' data-testid={testId}>
      {Array.from({ length }, (_, index) => (
        <input
          aria-label={`${label} ${index + 1}`}
          autoComplete={index === 0 ? 'one-time-code' : 'off'}
          className='bomdisoft-code-input-cell'
          disabled={disabled}
          inputMode='numeric'
          key={index}
          maxLength={length}
          onChange={event => setCell(index, event.target.value)}
          onKeyDown={onKeyDown(index)}
          ref={cell => {
            cellsRef.current[index] = cell;
          }}
          type='text'
          value={toCellValue(value, index)}
        />
      ))}
    </div>
  );
};
